import type { FC } from "react";
import MedicalInsuranceForm from "../MedicalInsuranceForm/MedicalInsuranceForm";

interface MedicalInsuranceStepProps {
  onSaved: () => void;
}

const MedicalInsuranceStep: FC<MedicalInsuranceStepProps> = ({ onSaved }) => {
  return (
    <>
      <MedicalInsuranceForm
        onStepChange={() => {}}
        onSaved={onSaved}
        closePopupOnSave={false}
      />
    </>
  );
};

export default MedicalInsuranceStep;
